import _slicedToArray from "/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/slicedToArray";
import React, { useEffect, useState } from 'react';
import { makeStyles } from 'tss-react/mui';
import { observer } from 'mobx-react';
import { getParent } from 'mobx-state-tree';
import { LoadingEllipses } from '@jbrowse/core/ui';
// icons
import RefreshIcon from '@mui/icons-material/Refresh';
// locals
import BlockMsg from './BlockMsg';
var useStyles = makeStyles()(function (theme) {
  var bg = theme.palette.action.disabledBackground;
  return {
    loading: {
      paddingLeft: '0.6em',
      backgroundColor: theme.palette.background.default,
      backgroundImage: "repeating-linear-gradient(45deg, transparent, transparent 5px, ".concat(bg, " 5px, ").concat(bg, " 10px)"),
      textAlign: 'center'
    }
  };
});
// eslint-disable-next-line @typescript-eslint/no-explicit-any
var LoadingMessage = observer(function (_ref) {
  var model = _ref.model;
  // only show the loading message after 300ms to prevent excessive flickering
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    shown = _useState2[0],
    setShown = _useState2[1];
  var _useStyles = useStyles(),
    classes = _useStyles.classes;
  useEffect(function () {
    var killed = false;
    var timeout = setTimeout(function () {
      if (!killed) {
        setShown(true);
      }
    }, 300);
    return function () {
      clearTimeout(timeout);
      killed = true;
    };
  }, []);
  var blockStatus = model.status; // eslint-disable-next-line @typescript-eslint/no-explicit-any
  var _getParent = getParent(model, 2),
    displayStatus = _getParent.message;
  var status = displayStatus || blockStatus;
  return React.createElement(React.Fragment, null, shown ? React.createElement("div", {
    className: classes.loading
  }, React.createElement(LoadingEllipses, {
    message: status
  })) : null);
});
var ServerSideRenderedBlockContent = observer(function (_ref2) {
  var model = _ref2.model;
  if (model.error) {
    return React.createElement(BlockMsg, {
      message: "".concat(model.error),
      severity: "error",
      buttonText: "reload",
      icon: React.createElement(RefreshIcon, null),
      action: model.reload
    });
  }
  if (model.message) {
    // the message can be a fully rendered react component, e.g. the region too large message
    return React.isValidElement(model.message) ? model.message : React.createElement(BlockMsg, {
      message: "".concat(model.message),
      severity: "info"
    });
  }
  if (!model.filled) {
    return React.createElement(LoadingMessage, {
      model: model
    });
  }
  return model.reactElement;
});
export default ServerSideRenderedBlockContent;